import { formatLocaleDate, formatLocalePercentageNumber } from "@/utils/formatUtils";
import { isDefined } from "@/utils/utils";
import { Card } from "antd";
import { useTranslation } from "react-i18next";
import { formatAgentName } from "../../../agent/utils";
import { ContractGainerKey, ContractGainerRateKey, ContractGainerRecord, GenericContract } from "../../types";

const getGainersName = (gainerRecord: ContractGainerRecord) => {
  return gainerRecord.gainer2
    ? Array.from({ length: 5 }, (_, i) => i + 1)
        .filter((i) => !!gainerRecord[`gainer${i}` as ContractGainerKey])
        .map((i) => {
          const rate = gainerRecord[`gainer${i}Rate` as ContractGainerRateKey];
          const name = formatAgentName(gainerRecord[`gainer${i}` as ContractGainerKey]);

          return isDefined(rate) ? `${name} - ${formatLocalePercentageNumber(rate)}` : name;
        })
        .join(", ")
    : formatAgentName(gainerRecord.gainer1);
};

interface Props {
  gainerRecords: GenericContract["gainerRecords"];
}

export const ContractGainerRecords = ({ gainerRecords = [] }: Props) => {
  const { t } = useTranslation();

  const multipleGainers = gainerRecords.length > 1;

  return gainerRecords.map((record) =>
    multipleGainers ? (
      <Card
        key={record.id}
        className={multipleGainers ? "margin-bottom-tiny" : undefined}
        size="small"
        style={{ width: "100%" }}
        styles={{ title: { fontWeight: 400 } }}
        title={
          multipleGainers
            ? `${t("contract.attrs.gainerRecords.startDate")}: ${formatLocaleDate(record.startDate)} ${record.endDate ? `- ${t("contract.attrs.gainerRecords.endDate")}: ${formatLocaleDate(record.endDate)}` : ""}`
            : undefined
        }
      >
        {getGainersName(record)}
      </Card>
    ) : (
      getGainersName(record)
    ),
  );
};
